import React from 'react';
import { Save } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { Input } from '../../components/ui/Input';
import { Checkbox } from '../../components/ui/Checkbox';
export function AdminSettings() {
  return <div className="min-h-screen bg-white" data-id="element-735">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-736">
        <div className="mb-8" data-id="element-737">
          <h1 className="text-3xl font-semibold text-neutral-900 mb-2" data-id="element-738">
            System Settings
          </h1>
          <p className="text-neutral-600" data-id="element-739">Configure system-wide settings</p>
        </div>

        <div className="space-y-6" data-id="element-740">
          <Card data-id="element-741">
            <CardHeader data-id="element-742">
              <CardTitle data-id="element-743">Organization Details</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4" data-id="element-744">
              <Input label="Organization Name" defaultValue="ATIOS" data-id="element-745" />
              <Input label="Contact Email" type="email" defaultValue="contact@atios.id" data-id="element-746" />
              <Input label="Support Email" type="email" defaultValue="support@atios.id" data-id="element-747" />
              <div className="flex justify-end pt-4" data-id="element-748">
                <Button data-id="element-749">
                  <Save className="w-4 h-4 mr-2" data-id="element-750" />
                  Save Changes
                </Button>
              </div>
            </CardContent>
          </Card>

          <Card data-id="element-751">
            <CardHeader data-id="element-752">
              <CardTitle data-id="element-753">Feature Flags</CardTitle>
            </CardHeader>
            <CardContent className="space-y-3" data-id="element-754">
              <Checkbox label="Enable job board" defaultChecked data-id="element-755" />
              <Checkbox label="Enable event registration" defaultChecked data-id="element-756" />
              <Checkbox label="Enable payment gateway" defaultChecked data-id="element-757" />
              <Checkbox label="Enable chapter management" defaultChecked data-id="element-758" />
              <div className="flex justify-end pt-4" data-id="element-759">
                <Button data-id="element-760">
                  <Save className="w-4 h-4 mr-2" data-id="element-761" />
                  Save Changes
                </Button>
              </div>
            </CardContent>
          </Card>

          <Card data-id="element-762">
            <CardHeader data-id="element-763">
              <CardTitle data-id="element-764">Email Settings</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4" data-id="element-765">
              <Input label="SMTP Host" placeholder="smtp.example.com" data-id="element-766" />
              <Input label="SMTP Port" placeholder="587" data-id="element-767" />
              <Input label="SMTP Username" placeholder="username" data-id="element-768" />
              <Input label="SMTP Password" type="password" placeholder="••••••••" data-id="element-769" />
              <div className="flex justify-end pt-4" data-id="element-770">
                <Button data-id="element-771">
                  <Save className="w-4 h-4 mr-2" data-id="element-772" />
                  Save Changes
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>;
}